import React from 'react'
import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import tutorialIcon from "../assets/icons/tutorial.svg";
import { Trans } from "react-i18next";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import loginMobileId from "../assets/image/loginGopaperlessAgent/loginMobileId.png";
import loginMobileId1 from "../assets/image/loginGopaperlessAgent/loginMobileId1.png";
import loginsuccess from "../assets/image/loginGopaperlessAgent/loginsuccess.png";
import loginGoogle from "../assets/image/loginGopaperlessAgent/loginGoogle.png";
import loginGoogle1 from "../assets/image/loginGopaperlessAgent/loginGoogle1.png";
import loginVNeID from "../assets/image/loginGopaperlessAgent/loginVNeID.png";
import loginVNeID1 from "../assets/image/loginGopaperlessAgent/loginVNeID1.png";
import loginVNeID2 from "../assets/image/loginGopaperlessAgent/loginVNeID2.png";
import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";

const LoginGopaperlessAgent = () => {
    const { t, i18n } = useTranslation();
    const [openMobileID, setOpenMobileID] = useState(true);
    const [openGoogle, setOpenGoogle] = useState(true);
    const [openVNeID, setOpenVNeID] = useState(true);
    const lastUpdated = "2026-03-05";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        const clean = (key) =>
            t(key)?.replace(/<[^>]+>/g, "").trim() || "";

        return `
${clean("loginGopaperlessAgent.loginMobileID")}

${clean("loginGopaperlessAgent.loginMobileIDstep1")}
${clean("loginGopaperlessAgent.loginMobileIDstep1sub")}

${clean("loginGopaperlessAgent.loginMobileIDstep2")}
${clean("loginGopaperlessAgent.loginMobileIDstep2sub")}
- ${clean("loginGopaperlessAgent.loginMobileIDstep2sub1")}
- ${clean("loginGopaperlessAgent.loginMobileIDstep2sub2")}
${clean("loginGopaperlessAgent.loginMobileIDstep2sub3")}

${clean("loginGopaperlessAgent.loginMobileIDstep3")}
${clean("loginGopaperlessAgent.loginMobileIDstep3sub")}
${clean("loginGopaperlessAgent.loginMobileIDstep3sub2")}
- ${clean("loginGopaperlessAgent.loginMobileIDstep3sub2item1")}
- ${clean("loginGopaperlessAgent.loginMobileIDstep3sub2item2")}
- ${clean("loginGopaperlessAgent.loginMobileIDstep3sub2item3")}
- ${clean("loginGopaperlessAgent.loginMobileIDstep3sub2item4")}

--------------------------------------------------

${clean("loginGopaperlessAgent.loginGoogle")}

${clean("loginGopaperlessAgent.loginGoogleStep1")}
${clean("loginGopaperlessAgent.loginGoogleStep1sub")}

${clean("loginGopaperlessAgent.loginGoogleStep2")}
${clean("loginGopaperlessAgent.loginGoogleStep2sub")}
- ${clean("loginGopaperlessAgent.loginGoogleStep2subitem1")}
- ${clean("loginGopaperlessAgent.loginGoogleStep2subitem2")}

--------------------------------------------------

${clean("loginGopaperlessAgent.loginVNeID")}

${clean("loginGopaperlessAgent.loginVNeIDStep1")}
${clean("loginGopaperlessAgent.loginVNeIDStep1sub")}

${clean("loginGopaperlessAgent.loginVNeIDStep2")}
${clean("loginGopaperlessAgent.loginVNeIDStep2sub")}
${clean("loginGopaperlessAgent.loginVNeIDStep2sub1")}
1. ${clean("loginGopaperlessAgent.loginVNeIDStep2sub1item1")}
2. ${clean("loginGopaperlessAgent.loginVNeIDStep2sub1item2")}

${clean("loginGopaperlessAgent.loginVNeIDStep2sub2")}

${clean("loginGopaperlessAgent.loginVNeIDStep3")}
${clean("loginGopaperlessAgent.loginVNeIDStep3sub")}
1. ${clean("loginGopaperlessAgent.loginVNeIDStep3subitem1")}
2. ${clean("loginGopaperlessAgent.loginVNeIDStep3subitem2")}
3. ${clean("loginGopaperlessAgent.loginVNeIDStep3subitem3")}
4. ${clean("loginGopaperlessAgent.loginVNeIDStep3subitem4")}

${clean("loginGopaperlessAgent.loginVNeIStep4")}
`.trim();
    };
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          py-3
          max-w-3xl
        "
            >
                <div className="relative flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1">
                        <div>
                            <img src={tutorialIcon} alt="tutorial" className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-[16px] tabletpro:text-[14px] mini_mobile:text-[14px] text-[#0087FE] font-normal">
                                {t("sidebar.usage.title").toUpperCase()}
                            </p>
                        </div>
                    </div>

                    <CopyButton text={buildCopyText(t)} />
                </div>

                <div className="mt-2 relative">
                    <section className='flex gap-4'>
                        <p className='text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[22px] mobile:text-[30px] mini_mobile:text-[24px] font-semibold'>{t("sidebar.usage.login")}</p>
                    </section>

                    <section className='flex flex-col gap-4 mt-1'>
                        <div
                            onClick={() => setOpenMobileID(!openMobileID)}
                            className="flex items-center justify-between cursor-pointer select-none"
                        >
                            <p className="text-[18px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileID"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            <FiChevronDown
                                className={`transition-transform duration-300 ${openMobileID ? "rotate-180" : ""
                                    }`}
                                size={20}
                            />
                        </div>
                        {openMobileID && (<div className='flex flex-col gap-4 mt-1'>
                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileIDstep1"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>
                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileIDstep1sub"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>
                            <Zoom zoomMargin={80} zoomImg={{
                                src: loginMobileId

                            }}>
                                <img
                                    src={loginMobileId}
                                    alt="loginMobileId"
                                    className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                />
                            </Zoom>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileIDstep2"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>
                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileIDstep2sub"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>
                            <ul className="list-disc pl-6 space-y-1">
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("loginGopaperlessAgent.loginMobileIDstep2sub1")}
                                </li>
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("loginGopaperlessAgent.loginMobileIDstep2sub2")}
                                </li>
                            </ul>
                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileIDstep2sub3"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            <Zoom zoomMargin={80} zoomImg={{
                                src: loginMobileId1

                            }}>
                                <img
                                    src={loginMobileId1}
                                    alt="loginMobileId1"
                                    className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                />
                            </Zoom>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileIDstep3"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileIDstep3sub"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            {/* <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileIDstep3sub1"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p> */}

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileIDstep3sub2"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            <ul className="list-disc pl-6 space-y-1">
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("loginGopaperlessAgent.loginMobileIDstep3sub2item1")}
                                </li>
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("loginGopaperlessAgent.loginMobileIDstep3sub2item2")}
                                </li>
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("loginGopaperlessAgent.loginMobileIDstep3sub2item3")}
                                </li>
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("loginGopaperlessAgent.loginMobileIDstep3sub2item4")}
                                </li>
                            </ul>

                            <Zoom zoomMargin={80} zoomImg={{
                                src: loginsuccess

                            }}>
                                <img
                                    src={loginsuccess}
                                    alt="loginsuccess"
                                    className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                />
                            </Zoom>
                        </div>)}

                        <div
                            onClick={() => setOpenGoogle(!openGoogle)}
                            className="flex items-center justify-between cursor-pointer select-none"
                        >
                            <p className="text-[18px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginGoogle"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            <FiChevronDown
                                className={`transition-transform duration-300 ${openGoogle ? "rotate-180" : ""
                                    }`}
                                size={20}
                            />
                        </div>

                        {openGoogle && (<div className='flex flex-col gap-4 mt-1'>
                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginGoogleStep1"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginGoogleStep1sub"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            <Zoom zoomMargin={80} zoomImg={{
                                src: loginGoogle

                            }}>
                                <img
                                    src={loginGoogle}
                                    alt="loginGoogle"
                                    className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                />
                            </Zoom>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginGoogleStep2"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginGoogleStep2sub"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            <ul className="list-disc pl-6 space-y-1">
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9] whitespace-pre-line">
                                    {t("loginGopaperlessAgent.loginGoogleStep2subitem1")}
                                </li>
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("loginGopaperlessAgent.loginGoogleStep2subitem2")}
                                </li>
                            </ul>

                            <Zoom zoomMargin={80} zoomImg={{
                                src: loginGoogle1

                            }}>
                                <img
                                    src={loginGoogle1}
                                    alt="loginGoogle1"
                                    className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                />
                            </Zoom>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileIDstep3"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileIDstep3sub"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            {/* <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileIDstep3sub1"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p> */}

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginMobileIDstep3sub2"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            <ul className="list-disc pl-6 space-y-1">
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("loginGopaperlessAgent.loginMobileIDstep3sub2item1")}
                                </li>
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("loginGopaperlessAgent.loginMobileIDstep3sub2item2")}
                                </li>
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("loginGopaperlessAgent.loginMobileIDstep3sub2item3")}
                                </li>
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("loginGopaperlessAgent.loginMobileIDstep3sub2item4")}
                                </li>
                            </ul>

                            <Zoom zoomMargin={80} zoomImg={{
                                src: loginsuccess

                            }}>
                                <img
                                    src={loginsuccess}
                                    alt="loginsuccess"
                                    className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                />
                            </Zoom>
                        </div>)}

                        <div
                            onClick={() => setOpenVNeID(!openVNeID)}
                            className="flex items-center justify-between cursor-pointer select-none"
                        >
                            <p className="text-[18px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="loginGopaperlessAgent.loginVNeID"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            <FiChevronDown
                                className={`transition-transform duration-300 ${openVNeID ? "rotate-180" : ""
                                    }`}
                                size={20}
                            />
                        </div>


                        {openVNeID && (
                            <div className='flex flex-col gap-4 mt-1'>
                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    <Trans
                                        i18nKey="loginGopaperlessAgent.loginVNeIDStep1"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    <Trans
                                        i18nKey="loginGopaperlessAgent.loginVNeIDStep1sub"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <Zoom zoomMargin={80} zoomImg={{
                                    src: loginVNeID

                                }}>
                                    <img
                                        src={loginVNeID}
                                        alt="loginVNeID"
                                        className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                    />
                                </Zoom>

                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    <Trans
                                        i18nKey="loginGopaperlessAgent.loginVNeIDStep2"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    <Trans
                                        i18nKey="loginGopaperlessAgent.loginVNeIDStep2sub"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    <Trans
                                        i18nKey="loginGopaperlessAgent.loginVNeIDStep2sub1"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <ul className="list-decimal pl-6 space-y-1">
                                    <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                        {t("loginGopaperlessAgent.loginVNeIDStep2sub1item1")}
                                    </li>
                                    <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                        {t("loginGopaperlessAgent.loginVNeIDStep2sub1item2")}
                                    </li>
                                </ul>

                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    <Trans
                                        i18nKey="loginGopaperlessAgent.loginVNeIDStep2sub2"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <Zoom zoomMargin={80} zoomImg={{
                                    src: loginVNeID1

                                }}>
                                    <img
                                        src={loginVNeID1}
                                        alt="loginVNeID1"
                                        className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                    />
                                </Zoom>

                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    <Trans
                                        i18nKey="loginGopaperlessAgent.loginVNeIDStep3"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    <Trans
                                        i18nKey="loginGopaperlessAgent.loginVNeIDStep3sub"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <ul className="list-decimal pl-6 space-y-1">
                                    <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                        {t("loginGopaperlessAgent.loginVNeIDStep3subitem1")}
                                    </li>
                                    <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                        {t("loginGopaperlessAgent.loginVNeIDStep3subitem2")}
                                    </li>
                                    <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                        {t("loginGopaperlessAgent.loginVNeIDStep3subitem3")}
                                    </li>
                                    <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                        {t("loginGopaperlessAgent.loginVNeIDStep3subitem4")}
                                    </li>
                                </ul>

                                <Zoom zoomMargin={80} zoomImg={{
                                    src: loginVNeID2

                                }}>
                                    <img
                                        src={loginVNeID2}
                                        alt="loginVNeID2"
                                        className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                    />
                                </Zoom>

                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    <Trans
                                        i18nKey="loginGopaperlessAgent.loginVNeIStep4"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    <Trans
                                        i18nKey="loginGopaperlessAgent.loginMobileIDstep3sub"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                {/* <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    <Trans
                                        i18nKey="loginGopaperlessAgent.loginMobileIDstep3sub1"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p> */}

                                <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    <Trans
                                        i18nKey="loginGopaperlessAgent.loginMobileIDstep3sub2"
                                        components={{
                                            strong: <span className="font-semibold" />,
                                        }}
                                    />
                                </p>

                                <ul className="list-disc pl-6 space-y-1">
                                    <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                        {t("loginGopaperlessAgent.loginMobileIDstep3sub2item1")}
                                    </li>
                                    <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                        {t("loginGopaperlessAgent.loginMobileIDstep3sub2item2")}
                                    </li>
                                    <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                        {t("loginGopaperlessAgent.loginMobileIDstep3sub2item3")}
                                    </li>
                                    <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                        {t("loginGopaperlessAgent.loginMobileIDstep3sub2item4")}
                                    </li>
                                </ul>

                                <Zoom zoomMargin={80} zoomImg={{
                                    src: loginsuccess

                                }}>
                                    <img
                                        src={loginsuccess}
                                        alt="loginsuccess"
                                        className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                    />
                                </Zoom>
                            </div>
                        )}
                    </section>

                    <section className='flex gap-4 mt-4 flex-col desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.usage.title")}
                            to="/userguide"
                        />
                        <NextSectionCard
                            label={t("sidebar.usage.viewCert")}
                            to="/view-cert"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default LoginGopaperlessAgent
